import { render, staticRenderFns } from "./ArticleListWithOtherNavigation.vue?vue&type=template&id=37879d73&scoped=true"
import script from "./ArticleListWithOtherNavigation.vue?vue&type=script&lang=ts"
export * from "./ArticleListWithOtherNavigation.vue?vue&type=script&lang=ts"
import style0 from "./ArticleListWithOtherNavigation.vue?vue&type=style&index=0&id=37879d73&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37879d73",
  null
  
)

export default component.exports